import { IInitialValue } from "us.collection.followup/interfaces";

export const activityFromInitail: IInitialValue = {
    activity: "",
    executingDateTime: "",
    executingDateTimeWithParameter: "",
    action: ''
}